// WebSocket connection manager for campaign event streams. When USE_MOCK is
// true we delegate to the in-process simulator. Otherwise we open a real
// WebSocket against `/api/campaigns/:id/stream`.

import type { WebSocketEvent } from "../types";
import { subscribeMockStream } from "../mock";
import { USE_MOCK } from "./client";

export type StreamHandler = (event: WebSocketEvent) => void;

export class CampaignStream {
  private unsubscribe: (() => void) | null = null;

  connect(id: string, onEvent: StreamHandler): void {
    this.disconnect();
    if (USE_MOCK) {
      this.unsubscribe = subscribeMockStream(id, onEvent);
      return;
    }
    const base = typeof window !== "undefined" ? window.location.origin : "";
    const wsUrl = base.replace(/^http/, "ws") + `/api/campaigns/${id}/stream`;
    const sock = new WebSocket(wsUrl);
    sock.onmessage = (ev) => {
      try {
        const parsed = JSON.parse(ev.data) as WebSocketEvent;
        onEvent(parsed);
      } catch {
        // Swallow — malformed frame.
      }
    };
    this.unsubscribe = () => {
      try {
        sock.close();
      } catch {
        // Ignore close errors.
      }
    };
  }

  disconnect(): void {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
  }
}
